module.exports = __webpack_public_path__ + "img/specialistNo1.9b609b51.png";